module.exports = __webpack_public_path__ + "img/zhongguopijuwenhuayuan.f8261ef5.png";